import { render, staticRenderFns } from "./OrderFabricRawFabricTypeTable.vue?vue&type=template&id=4c8b58bc&scoped=true&"
import script from "./OrderFabricRawFabricTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricRawFabricTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b58bc",
  null
  
)

export default component.exports